<style lang="scss">
$teal:      #5bb8b1;
$teal-dark: #2c7d76;
$teal-bg:   #e4f3f0;
$dark:      #1a1a2e;
$gray:      #6c7280;
$font:      'Segoe UI', system-ui, sans-serif;

.disc-wrap {
  background: $teal-bg !important;
  min-height: 100vh;
  font-family: $font;
}

.disc-page-container {
  padding-top: 24px;
  padding-bottom: 90px;

  @media (min-width: 768px)  { padding-top: 32px; }
  @media (min-width: 1024px) { padding-top: 40px; max-width: 860px; margin: 0 auto; }
}

.disc-heading {
  margin-bottom: 20px;

  &__title {
    font-size: 20px;
    font-weight: 700;
    color: $teal-dark;
    margin: 0 0 6px;

    @media (min-width: 768px) { font-size: 24px; }
  }

  &__sub {
    font-size: 13px;
    color: $gray;
    margin: 0;
  }
}

.disc-card {
  background: #fff;
  border-radius: 14px;
  border: 1.5px solid rgba(91, 184, 177, 0.2);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  font-family: $font;

  &__body {
    padding: 20px;
    font-size: 14px;
    color: $dark;
    line-height: 1.7;

    @media (min-width: 768px) { padding: 28px; font-size: 15px; }
  }
}

.attorney-email-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 420px;

  label {
    font-size: 13px;
    font-weight: 700;
    color: $dark;
  }

  input {
    height: 44px;
    border: 1.5px solid rgba(91, 184, 177, 0.35);
    border-radius: 8px;
    padding: 0 14px;
    font-size: 14px;
    color: $dark;
    font-family: $font;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus {
      border-color: $teal;
      box-shadow: 0 0 0 3px rgba(91, 184, 177, 0.18);
    }

    &.has-error { border-color: #c0392b; }
  }
}

.attorney-email-error {
  margin-top: 10px;
  font-size: 13px;
  color: #c0392b;
}
</style>

<template>
  <section class="disc-wrap content d-flex flex-column flex-column-fluid">
    <div class="d-flex flex-column-fluid">
      <div class="container-fluid disc-page-container">

        <div class="disc-heading">
          <h2 class="disc-heading__title">Attorney Verification</h2>
          <p class="disc-heading__sub">This service requires verification with an approved attorney before you can continue.</p>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="disc-card">
              <div class="disc-card__body">
                <p>Please enter the email address of the attorney handling this request.</p>

                <div class="attorney-email-field">
                  <label for="attorney-email-input">Attorney Email</label>
                  <input
                    id="attorney-email-input"
                    type="email"
                    v-model="email"
                    :class="{ 'has-error': errorMsg }"
                    placeholder="attorney@example.com"
                    @keyup.enter="nextStep"
                  />
                </div>

                <div class="attorney-email-error" v-if="errorMsg">
                  <i class="fa fa-exclamation-circle"></i> {{ errorMsg }}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <v-foooter
        v-on:next="nextStep"
        v-on:back="back"
        :btnname="verifying ? 'Verifying…' : 'Next'"
        :backname="'Back'"
      ></v-foooter>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import vFoooter from "./citizen/foooter.vue";
import { VERIFY_ATTORNEY_EMAIL } from "@/core/services/store/actions.type";
import { SET_VERIFIED_ATTORNEY_EMAIL } from "@/core/services/store/mutations.type";

export default {
  components: {
    vFoooter,
  },
  data() {
    return {
      email: "",
      errorMsg: "",
      verifying: false,
    };
  },
  computed: {
    ...mapGetters(["getfServiceSlug"]),
  },
  methods: {
    back() {
      this.$router.push({
        name: "frontend.agent.locations",
        params: { slug: this.getfServiceSlug },
      });
    },
    nextStep() {
      if (this.verifying) return;
      const email = this.email.trim();
      if (!email) {
        this.errorMsg = "Please enter the attorney's email address.";
        return;
      }
      this.verifying = true;
      this.errorMsg = "";
      this.$store
        .dispatch(VERIFY_ATTORNEY_EMAIL, email)
        .then(() => {
          this.verifying = false;
          this.$store.commit(SET_VERIFIED_ATTORNEY_EMAIL, email);
          var client_slug = this.$route.params.client_slug;
          var id = this.$route.params.id;
          this.$router.push({ name: "client.appointment.request-letter", params: { id, client_slug } });
        })
        .catch(err => {
          this.verifying = false;
          this.errorMsg = (err && err.msg) || "Unable to verify attorney email.";
        });
    },
  },
};
</script>
